"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var utils_1 = require("./utils");
exports.sessionStore = function () {
    var get = function (flagName) {
        return utils_1.safeParseJSON(window.sessionStorage.getItem(utils_1.getKey(flagName)));
    };
    return {
        name: 'sessionStore',
        get: get,
        set: function (flagName, value) {
            return window.sessionStorage.setItem(utils_1.getKey(flagName), JSON.stringify(value));
        },
        remove: function (flagName) { return window.sessionStorage.removeItem(utils_1.getKey(flagName)); },
        all: function () { return utils_1.mapFromStoredValuesWithPrefix(window.sessionStorage, get); }
    };
};
//# sourceMappingURL=session-store.js.map